import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, ValidationErrors, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-communication-form[type]',
  templateUrl: './user-communication-form.component.html',
  styleUrls: ['./user-communication-form.component.scss']
})
export class UserCommunicationFormComponent implements OnChanges {
  @Input() type!: 'phone' | 'email';
  @Input() defaultValues: string[] = [];
  @Input() required = false;
  @Input() outsider = false;

  public formArray: FormArray;

  public get arrayControls(): FormControl[] {
    return this.formArray?.controls as FormControl[];
  }

  constructor(private fb: FormBuilder) {
    this.formArray = this.fb.array([]);
  }

  ngOnInit(): void {}

  ngOnChanges(change: SimpleChanges): void {
    const defValuesChange = change.defaultValues;
    if (defValuesChange && defValuesChange.currentValue) {
      defValuesChange.currentValue.forEach((value: string) => this.onAdd(value));
    }
  }

  /**
   * USED IN PARENT COMPONENT
   * @return list of emails / phone numbers
   */
  public summaryData(): string[] {
    return this.formArray.value;
  }

  /**
   * USED IN PARENT COMPONENT
   * @return invalid form flag
   */
  public get invalid(): boolean {
    this.formArray.markAllAsTouched();
    return (this.required && this.formArray.length == 0) || this.formArray.invalid;
  }

  /**
   * USED IN PARENT COMPONENT
   * @return list of errors
   */
  public get errors(): ValidationErrors | null {
    return this.formArray.errors;
  }

  public onAdd(value: string | null): void {
    this.formArray.push(
      this.fb.control(value, this.type == 'email' ? [Validators.required, Validators.email] : [Validators.required])
    );
  }

  public onDelete(index: number): void {
    this.formArray.removeAt(index);
  }

  // USED IN PARENT COMPONENT
  public get dirty(): boolean {
    return this.formArray.dirty;
  }
}
